export default __webpack_public_path__ + "static/media/sort-za.b06743c5.svg";